(()=>{
  const STORAGE_KEY='pianziWishlist';
  const money=(cents)=>{
    try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format((Number(cents)||0)/100)}catch(e){return `$${((Number(cents)||0)/100).toFixed(2)}`}
  };
  const getWishlist=()=>{try{const v=JSON.parse(localStorage.getItem(STORAGE_KEY)||'[]');return Array.isArray(v)?v:[]}catch(e){return[]}};
  const wishlistIds=(items=getWishlist())=>items.map(item=>String(typeof item==='object'?item.id:item));
  const setWishlist=(items)=>{localStorage.setItem(STORAGE_KEY,JSON.stringify(items));document.dispatchEvent(new CustomEvent('pianzi:wishlist-change',{detail:{items}}))};
  let modal;
  let currentCard;
  let currentProduct;
  let selections=[];

  function ensureModal(){
    if(modal)return modal;
    modal=document.createElement('div');
    modal.className='pianzi-quick-shop';
    modal.setAttribute('aria-hidden','true');
    modal.innerHTML=`
      <div class="pianzi-quick-shop__backdrop" data-pianzi-quick-close></div>
      <section class="pianzi-quick-shop__panel" role="dialog" aria-modal="true" aria-labelledby="PianziQuickShopTitle">
        <header class="pianzi-quick-shop__header">
          <div><div class="pianzi-quick-shop__eyebrow">Quick selection</div><h2 class="pianzi-quick-shop__title" id="PianziQuickShopTitle"></h2></div>
          <button class="pianzi-quick-shop__close" type="button" aria-label="Close" data-pianzi-quick-close><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg></button>
        </header>
        <div class="pianzi-quick-shop__body" data-pianzi-quick-body></div>
        <div class="pianzi-quick-shop__error" data-pianzi-quick-error role="status" aria-live="polite"></div>
        <footer class="pianzi-quick-shop__footer"><div class="pianzi-quick-shop__price" data-pianzi-quick-price></div><button class="pianzi-quick-shop__add" type="button" data-pianzi-quick-add>Add to bag</button></footer>
      </section>`;
    document.body.appendChild(modal);
    modal.querySelectorAll('[data-pianzi-quick-close]').forEach(x=>x.addEventListener('click',closeModal));
    modal.querySelector('[data-pianzi-quick-add]').addEventListener('click',addSelectedVariant);
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&modal.classList.contains('is-open'))closeModal()});
    return modal;
  }

  function openModal(card){
    const dataNode=card.querySelector('[data-pianzi-product-json]');
    if(!dataNode)return;
    try{currentProduct=JSON.parse(dataNode.textContent)}catch(e){console.error(e);return}
    currentCard=card;
    selections=currentProduct.options.map((opt,index)=>{
      const available=currentProduct.variants.find(v=>v.available);
      return available?.options?.[index]||opt.values[0];
    });
    const el=ensureModal();
    el.querySelector('.pianzi-quick-shop__title').textContent=currentProduct.title;
    renderOptions();
    el.classList.add('is-open');
    el.setAttribute('aria-hidden','false');
    document.body.classList.add('pianzi-quick-shop-open');
    requestAnimationFrame(()=>el.querySelector('.pianzi-quick-shop__close')?.focus());
  }
  function closeModal(){if(!modal)return;modal.classList.remove('is-open');modal.setAttribute('aria-hidden','true');document.body.classList.remove('pianzi-quick-shop-open')}
  function matchingVariant(){
    return currentProduct?.variants?.find(v=>v.options.every((value,i)=>value===selections[i]));
  }
  function availableVariants(){
    return (currentProduct?.variants||[]).filter(v=>v.available);
  }
  function valueAvailable(optionIndex,value){
    return availableVariants().some(v=>
      v.options[optionIndex]===value &&
      v.options.every((optionValue,i)=>i===optionIndex||optionValue===selections[i])
    );
  }
  function selectOption(optionIndex,value){
    if(!valueAvailable(optionIndex,value))return;
    selections[optionIndex]=value;
    const next=matchingVariant();
    if(next?.available) selections=[...next.options];
    renderOptions();
  }
  function renderOptions(){
    const body=modal.querySelector('[data-pianzi-quick-body]');
    body.innerHTML='';
    currentProduct.options.forEach((option,index)=>{
      if(option.name==='Title'&&option.values.length===1&&option.values[0]==='Default Title')return;
      const group=document.createElement('div');group.className='pianzi-quick-shop__option';
      group.innerHTML=`<div class="pianzi-quick-shop__option-title">${option.name}</div><div class="pianzi-quick-shop__values"></div>`;
      const values=group.querySelector('.pianzi-quick-shop__values');
      const isColor=/colou?r/i.test(option.name);
      if(isColor)values.classList.add('pianzi-quick-shop__values--swatches');
      option.values.forEach(value=>{
        const btn=document.createElement('button');
        btn.type='button';
        btn.className=`pianzi-quick-shop__value${isColor?' pianzi-quick-shop__value--swatch':''}`;
        if(isColor){
          const swatch=currentProduct.swatches?.[option.name]?.[value]||'#D9D9D7';
          btn.style.setProperty('--quick-swatch',swatch);
          btn.innerHTML=`<span class="pianzi-quick-shop__swatch-chip" aria-hidden="true"></span><span>${value}</span>`;
        }else{
          btn.textContent=value;
        }
        btn.classList.toggle('is-selected',selections[index]===value);
        btn.disabled=!valueAvailable(index,value);
        btn.addEventListener('click',()=>selectOption(index,value));
        values.appendChild(btn);
      });
      body.appendChild(group);
    });
    const variant=matchingVariant();
    const error=modal.querySelector('[data-pianzi-quick-error]');
    if(error)error.textContent='';
    const add=modal.querySelector('[data-pianzi-quick-add]');
    add.disabled=!variant?.available;
    add.dataset.variantId=variant?.id||'';
    add.textContent=variant?.available?'Add to bag':'Unavailable';
    modal.querySelector('[data-pianzi-quick-price]').textContent=variant?money(variant.price):'';
  }
  async function addSelectedVariant(){
    const add=modal.querySelector('[data-pianzi-quick-add]');
    const error=modal.querySelector('[data-pianzi-quick-error]');
    const variant=matchingVariant();
    const id=Number(add.dataset.variantId);
    if(!id||add.disabled||!variant?.available)return;

    add.disabled=true;
    add.textContent='Adding…';
    if(error)error.textContent='';

    try{
      const root=window.Shopify?.routes?.root||'/';
      const res=await fetch(`${root}cart/add.js`,{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({
          items:[{id,quantity:1}],
          sections:['cart-drawer','cart-icon-bubble'],
          sections_url:window.location.pathname
        })
      });
      const state=await res.json();
      if(!res.ok||state.status>=400){
        throw new Error(state.description||state.message||'This option is no longer available.');
      }

      const drawer=document.querySelector('cart-drawer');
      if(drawer?.renderContents&&state.sections){
        drawer.renderContents(state);
      }else{
        document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        drawer?.open?.();
      }
      closeModal();
    }catch(err){
      console.error('PIANZI quick shop add failed:',err);
      if(error)error.textContent=err.message||'This option could not be added. Please choose another size or color.';
      add.disabled=!matchingVariant()?.available;
      add.textContent=matchingVariant()?.available?'Add to bag':'Unavailable';
      return;
    }finally{
      if(!error?.textContent){
        add.disabled=!matchingVariant()?.available;
        add.textContent=matchingVariant()?.available?'Add to bag':'Unavailable';
      }
    }
  }

  function init(scope=document){
    const wishlist=wishlistIds();
    scope.querySelectorAll('[data-pianzi-grid-card]:not([data-grid-ready])').forEach(card=>{
      card.dataset.gridReady='true';
      const id=String(card.dataset.productId);
      const image=card.querySelector('.pianzi-grid-card__image--primary');
      const originalImage=image?{src:image.currentSrc||image.src,srcset:image.getAttribute('srcset')||''}:null;
      const preview=(btn,commit=false)=>{
        if(btn.disabled)return;
        if(commit){
          card.querySelectorAll('[data-pianzi-swatch]').forEach(x=>x.classList.remove('is-active'));
          btn.classList.add('is-active');
        }
        if(image&&btn.dataset.imageSrc){
          image.classList.add('is-swatch-changing');
          window.setTimeout(()=>{image.src=btn.dataset.imageSrc;image.removeAttribute('srcset');image.classList.remove('is-swatch-changing')},90);
        }
      };
      card.querySelectorAll('[data-pianzi-swatch]').forEach(btn=>{
        btn.addEventListener('mouseenter',()=>preview(btn,false));
        btn.addEventListener('focus',()=>preview(btn,false));
        btn.addEventListener('click',()=>preview(btn,true));
      });
      card.addEventListener('mouseleave',()=>{
        const active=card.querySelector('[data-pianzi-swatch].is-active');
        if(active?.dataset.imageSrc){image.src=active.dataset.imageSrc;image.removeAttribute('srcset')}
        else if(image&&originalImage){image.src=originalImage.src;if(originalImage.srcset)image.setAttribute('srcset',originalImage.srcset)}
      });
      const favorite=card.querySelector('[data-pianzi-favorite]');
      if(favorite){
        const active=wishlist.includes(id);favorite.classList.toggle('is-active',active);favorite.setAttribute('aria-pressed',String(active));
        favorite.addEventListener('click',()=>{
          const list=getWishlist();const index=list.findIndex(item=>String(typeof item==='object'?item.id:item)===id);
          if(index>=0)list.splice(index,1);else{
            let product={};try{product=JSON.parse(card.querySelector('[data-pianzi-product-json]')?.textContent||'{}')}catch(e){}
            list.push({id,handle:card.dataset.productHandle||'',title:product.title||card.querySelector('.pianzi-grid-card__title')?.textContent.trim()||'Product',url:product.url||card.querySelector('.pianzi-grid-card__media-link')?.getAttribute('href')||'#',image:product.featuredImage||card.querySelector('.pianzi-grid-card__image--primary')?.currentSrc||'',price:''});
          }
          setWishlist(list);const isActive=wishlistIds(list).includes(id);favorite.classList.toggle('is-active',isActive);favorite.setAttribute('aria-pressed',String(isActive));favorite.setAttribute('aria-label',`${isActive?'Remove':'Add'} ${card.querySelector('.pianzi-grid-card__title')?.textContent.trim()||'product'} ${isActive?'from':'to'} wishlist`)
        });
      }
      card.querySelector('[data-pianzi-quick-shop]')?.addEventListener('click',()=>openModal(card));
    });
  }
  document.addEventListener('DOMContentLoaded',()=>init());
  document.addEventListener('shopify:section:load',e=>init(e.target));
  new MutationObserver(m=>m.forEach(x=>x.addedNodes.forEach(n=>{if(n.nodeType===1)init(n)}))).observe(document.documentElement,{childList:true,subtree:true});
})();
